import {Directive, TemplateRef} from '@angular/core'

@Directive({
  selector: '[list-header]',
  standalone: false,
})
export class FilterListHeaderDirective {
  constructor(private tpl: TemplateRef<any>) {}
}
